"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ComponentRemoveStore_1 = require("./model/ComponentRemoveStore");
var removeComponent = function (opts) {
    ComponentRemoveStore_1.ComponentRemoveStore.init(opts);
};
exports.removeComponent = removeComponent;
